module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d0658279229463ee5e53850f4cfea6d3.png";